import React from 'react'
import Navbar from '../components/Navbar'
import Baner from '../components/Baner'
import bg from '../assets/bg-leasingi.jpg'
import Footer from '../components/Footer'

const Leasingi = () => {

  const rodzaje = [
    {
      id: 1,
      text: "Leasing operacyjny",
      text2: "Ta forma finansowania pozwala odliczyć raty leasingowe od kosztu uzyskania przychodu przedsiębiorcy. Amortyzacja przedmiotu leasingu leży po stronie finansującego. Z reguły czas trwania umowy leasingu operacyjnego jest krótszy niż normatywne cykl eksploatacji przedmiotu umowy, a także krótszy niż standardowy okres amortyzacji.",
    },{
      id: 2,
      text: "Leasing finansowy",
      text2: "zwany także kapitałowym. W tym wypadku kwestie podatkowe uregulowane są podobnie jak w przypadku kredytu. Przedmiot kontaktu stanowi własność finansującego, ale nie podlega u niego amortyzacji. Leasingobiorca zaś użytkuje przedmiot za cenę rat miesięcznych. Po okresie podstawowym umowy następuje przewłaszczenie, na warunkach wcześniej ustalonych. Korzystający opłaca miesięczne noty obciążeniowe, gdzie tylko część odsetka stanowi koszt uzyskania przychodu. Istotny jest natomiast fakt, że podatek VAT opłacany jest jednorazowo z góry całości za cały okres umowy.",
    },{
      id: 3,
      text: "Leasing zwrotny",
      text2: "który następuje, gdy firma oddaje własny środek trwały firmie leasingowej, która go kupuje i oddaje w użytkowanie sprzedającemu. Dzięki temu przedsiębiorca otrzymuje zastrzyk gotówki i spłaca raty leasingowe zgodnie z przyjętym harmonogramem.",
    },
  ]

  const zalety = [
    {
      id: 1, 
      text: "Większość przedsiębiorców użytkuje pojazdy w sposób mieszany. Korzystają z nich w firmie oraz prywatnie.",
    },{
      id: 2, 
      text: "Zakup nowego pojazdu lub innego przedmiotu to zazwyczaj spory wydatek dla przedsiębiorstwa. Natomiast wybór oferty leasingowej pozwala na niewielkie zaangażowanie własnego kapitału. Dzięki temu unikamy ryzyka związanego z utratą płynności finansowej firmy.",
    },{
      id: 3, 
      text: "W przypadku wykorzystania przedmiotu leasingowanego wyłącznie do celów prowadzenia działalności odliczamy 100% podatku. Taki pojazd należy zgłosić w urzędzie skarbowym oraz ewidencjonować przebieg kilometrów.",
    },
  ]

  return (
    <div>
      <Navbar />
      <Baner bg={bg} text="Leasingi" text2="Leasing to najpopularniejsza forma finansowania wśród przedsiębiorców. Z pomocą naszego eksperta znajdziemy najlepsze rozwiązanie."/>
      <div className='w-full'>
        <div className='justify-center flex mx-auto max-w-[1450px] bg-white'>
          <div className='text-center px-10'>
            <div className='pt-20'>
              <h2 className='text-3xl font-semibold'>Zalety leasingu</h2>
              <div className='grid sm:grid-cols-3 pt-5'>
                {zalety.map((item) => (
                  <div key={item.id} className='px-5'>
                      <p>{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className='pt-20'>
              <h2 className='text-3xl font-semibold'>Rodzaje umów leasingowych</h2>
              <div className='grid sm:grid-cols-3 pt-5'>
                {rodzaje.map((item) => (
                  <div key={item.id} className='px-5 pt-5 sm:pt-0'>
                      <p className='text-xl font-semibold pb-2'>{item.text}</p>
                      <p>{item.text2}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Leasingi